import { OrderType } from 'enums';
import { CashbackPage } from 'features/cashback';

export const AdminPayoutCashbackPage: React.FC = () => (
  <CashbackPage orderType={OrderType.Payout} />
);
